import { FormService } from './../services/form.service';
import { ResponseService } from './../services/response.service';
import { NotificationsService } from 'angular2-notifications';
import { Router } from '@angular/router';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LocalStorageService } from './../services/local-storage.service';
import { environment } from '../../environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { FormControl, FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from './../services/api.service';

@Component({
  selector: 'app-main',
  templateUrl: './rodo.component.html'
})


export class RodoComponent implements OnInit {

  public API_URL: any = `${environment.api_url}`;
  public acceptRodoForm: FormGroup;
  public view: any;

  constructor(
    private notificationService: NotificationsService,
    private domSanitizer: DomSanitizer,
    private formService: FormService,
    private responseService: ResponseService,
    private router: Router,
    private trans: TranslateService,
    private apiService: ApiService
  ) {
    let controls = {
      accept_rodo: new FormControl(false)
    };

    let validators = {
      accept_rodo: [Validators.required, Validators.pattern('true')]
    };
    this.acceptRodoForm = this.formService.buildForm(controls, validators);
  }

  ngOnInit() {
    this.appendRodo();
  }

  private appendRodo() {
    this.view = this.domSanitizer.bypassSecurityTrustHtml('<object style="width:100%;height:100%" type="application/pdf" '+ 
      'data="' + this.API_URL + '/rodo/information_obligation?mode=view">' +
      '<p>Obowiązek informacyjny nie może zostać otwarty, proszę spróbować ponownie za chwilę</p>' +
      '<a href="' + this.API_URL + '/rodo/information_obligation" target="_rodo" title="Obowiązek informacyjny PDF">Pobierz plik PDF</a> ' +
      '</object>');
  }

  saveAcceptedRodo() {
    if (this.acceptRodoForm.valid) {
      this.apiService.post('/rodo/client', {})
        .subscribe(
        (response) => {
          if(response.status.message == 'rodo.client.already_accepted'){
            this.router.navigateByUrl('/panel');
            return;
          }
          this.notificationService.remove();
          this.notificationService.success('OK!', this.trans.instant(response.status.message.toUpperCase()));
          this.router.navigateByUrl('/panel');
          //return;
        },
        (error) => {
          if(error.status.message === 'rodo.client.already_accepted'){
            this.router.navigateByUrl('/panel');
            return;
          }
          this.responseService.error(error, this.acceptRodoForm);
        });
    } else {
      this.notificationService.error('Weryfikacja', this.trans.instant('RODO.NEED.CHECK'));
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/rodo/rodo.component.ts